<template>
  <b-modal :active.sync="active"
      has-modal-card full-screen :can-cancel="false">
    <div class="modal-card">
      <header class="modal-card-head">
        <div class="columns is-centered" style="width: 100%">
          <div class="column is-half">
            <p v-if=viewMode class="modal-card-title">Detalle de Usuario</p>
            <p v-else class="modal-card-title">{{ userId ? 'Editar Usuario' : 'Ingreso Usuario'}}</p>
          </div>
        </div>
      </header>
      <section class="modal-card-body" >
        <ValidationObserver ref="observer">
        <div class="columns is-centered" style="width: 100%">
          <div class="column is-half">
            <h1 class="title is-5">Información Básica</h1>
            <b-field grouped>
              <b-field label="Primer Nombre"  label-position="inside" expanded>
                <ValidationProvider name="Primer Nombre" rules="required" v-slot="{ errors }">
                  <b-field :type="{ 'is-danger': errors[0] }" :message="errors">
                    <b-input type="text"  v-model="user.name"  placeholder ="Primer nombre de usuario" :disabled="viewMode"></b-input>
                  </b-field>
                </ValidationProvider>
              </b-field>
              <b-field label="Segundo nombre" label-position="inside" expanded>
                <b-input type="text" v-model="user.second_name" placeholder="Segundo nombre de jinete" :disabled="viewMode"></b-input>
              </b-field>
            </b-field>
            <b-field grouped>
              <b-field label="Primer Apellido" label-position="inside" expanded>
                <ValidationProvider name="Primer Apellido" rules="required" v-slot="{ errors }">
                  <b-field :type="{ 'is-danger': errors[0] }" :message="errors">
                    <b-input type="text"  v-model="user.lastname"  placeholder="Primer apellido de usuario" :disabled="viewMode"></b-input>
                  </b-field>
                </ValidationProvider>
              </b-field>
              <b-field label="Segundo Apellido" label-position="inside" expanded>
                <b-input type="text" v-model="user.second_lastname" placeholder="Segundo apellido de usuario" :disabled="viewMode"></b-input>
              </b-field>
            </b-field>
            <b-field grouped>
              <b-field label="Fecha de Nacimiento" label-position="inside" expanded>
                <ValidationProvider name="Fecha de Nacimiento" rules="" v-slot="{ errors }">
                  <b-field :type="{ 'is-danger': errors[0] }" :message="errors">
                    <b-datepicker
                      v-model="birthDate"
                      :first-day-of-week="1"
                      :month-names="$moment.months()"
                      :day-names="$moment.weekdaysShort()"
                      :show-week-number="true"
                      placeholder="Click para seleccionar"
                      icon="calendar-today"
                      :disabled="viewMode">
                    </b-datepicker>
                  </b-field>
                </ValidationProvider>
              </b-field>
              <b-field label="Género" label-position="inside" expanded>
                <ValidationProvider name="Género" rules="required" v-slot="{ errors }">
                  <b-field :type="{ 'is-danger': errors[0] }" :message="errors">
                    <b-select v-model="person.gender" placeholder="Seleccione un género" :disabled="viewMode" expanded>
                      <option v-for="option in genders" :value="option.code" :key="option.code">
                          {{ option.name }}
                      </option>
                    </b-select>
                  </b-field>
                </ValidationProvider>
              </b-field>
            </b-field>

            <h1 class="title is-5">Información de Contacto</h1>
            <b-field grouped>
              <b-field label="Dirección" label-position="inside" expanded>
                <b-input type="text" v-model="person.address" placeholder="Dirección de residencia" :disabled="viewMode">
                </b-input>
              </b-field>
              <b-field label="Teléfono" label-position="inside" expanded>
                <b-input type="text" v-model="person.phone" placeholder="Teléfono de contacto" :disabled="viewMode">
                </b-input>
              </b-field>
            </b-field>

            <h1 class="title is-5">Información Cuenta</h1>
            <b-field grouped>
              <b-field label="Nombre Usuario" label-position="inside" expanded>
                <b-input type="text" v-model="user.username" placeholder="Nombre de cuenta" :disabled="viewMode"></b-input>
              </b-field>
              <b-field label="Email" label-position="inside" expanded>
                <ValidationProvider name="Email" :rules="`required|email|is:${confirmEmail}`" v-slot="{ errors }">
                  <b-field :type="{ 'is-danger': errors[0], 'is-success': emailAvailable }" :message="errors[0] === '{field} is not valid' ? 'El correo ya se encuentra registrado' : errors">
                    <b-input type="email" v-model="user.email" @input="verifyEmail($event, errors[0])" placeholder="Correo electrónico" :disabled="viewMode"></b-input>
                  </b-field>
                </ValidationProvider>
              </b-field>
            </b-field>
            <div class="columns">
              <div class="column is-4">
                <b-field label="Activo" v-if="userId">
                  <b-switch v-model="user.user_status_id"
                    :true-value="1"
                    :false-value="2"
                    :disabled="viewMode"
                  >
                    {{user.user_status_id === 1 ? 'Si' : 'No'}}
                  </b-switch>
                </b-field>
              </div>
              <div class="column is-4">
                <b-field label="Acceso a App Web" v-if="userId">
                  <b-switch v-model="user.disabled_web"
                    :true-value="false"
                    :false-value="true"
                    :disabled="viewMode"
                  >
                    {{user.disabled_web === false ? 'Si' : 'No'}}
                  </b-switch>
                </b-field>
              </div>
              <div class="column is-4">
                <b-field label="Acceso a App Móvil" v-if="userId">
                  <b-switch v-model="user.disabled_mobile"
                    :true-value="false"
                    :false-value="true"
                    :disabled="viewMode"
                  >
                    {{user.disabled_mobile === false ? 'Si' : 'No'}}
                  </b-switch>
                </b-field>
              </div>
            </div>
            <b-field v-if="!viewMode" grouped>
              <b-field label="Cambiar contraseña" v-if="userId">
                <b-switch v-model="changePassword">
                    {{changePassword ? 'Si' : 'No'}}
                </b-switch>
              </b-field>
              <template v-if="changePassword || !userId">
                <b-field label="Contraseña" label-position="inside" expanded>
                  <ValidationProvider name="Contraseña" rules="required|min:8" v-slot="{ errors }">
                    <b-field :type="{ 'is-danger': errors[0] }" :message="errors">
                      <b-input type="password" v-model="user.password" password-reveal placeholder="contraseña">
                      </b-input>
                    </b-field>
                  </ValidationProvider>
                </b-field>
                <b-field label="Repetir Contraseña" label-position="inside" expanded>
                  <ValidationProvider name="Repetir Contraseña" :rules="`required|min:8|is:${user.password}`" v-slot="{ errors }">
                    <b-field :type="{ 'is-danger': errors[0] }" :message="errors[0] === '{field} is not valid' ? 'Las contraseñas deben ser iguales' : errors">
                      <b-input v-model="confirmPassword" type="password" password-reveal placeholder="repetir contraseña">
                      </b-input>
                    </b-field>
                  </ValidationProvider>
                </b-field>
              </template>
            </b-field>
            <br>
            <user-role-select :userRoles.sync="roles" :current-roles="roles" :view-mode="viewMode"/>
          </div>
        </div>
        </ValidationObserver>
      </section>
      <footer class="modal-card-foot">
        <div class="columns is-centered" style="width: 100%">
          <div class="column is-half">
            <div class="columns">
              <div class="column">
                <b-button expanded @click="cancel" :disabled="isLoading">Cerrar</b-button>
              </div>
              <div v-if="!viewMode" class="column">
                <b-button type="is-primary" expanded @click="save" :loading="isLoading">Guardar</b-button>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import PersonService from '@/services/PersonService'
import UserService from '@/services/UserService'
import UserRoleSelect from './UserRoleSelect'

export default {
  components: {
    UserRoleSelect
  },
  props: {
    active: {
      type: Boolean,
      required: false,
      default: false
    },
    userId: {
      required: false,
      default: null
    },
    viewMode: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  created () {
    if (this.userId) {
      this.getUser()
    } else {
      this.roles = []
    }
  },
  data () {
    return {
      isLoading: false,
      genders: [
        { code: 'M', name: 'Masculino' },
        { code: 'F', name: 'Femenino' }
      ],
      birthDate: null,
      confirmPassword: null,
      changePassword: false,
      oldEmail: null,
      user: {
        name: null,
        second_name: null,
        lastname: null,
        second_lastname: null,
        username: null,
        email: null,
        user_status_id: 1,
        roles: []
      },
      person: {
        gender: null,
        birth_date: null,
        address: null,
        phone: null
      },
      roles: [],
      confirmEmail: null
    }
  },
  methods: {
    cancel () {
      this.$emit('update:active', false)
      this.$emit('update:userId', null)
      this.resetForm()
    },
    resetForm () {
      this.birthDate = null
      this.confirmPassword = null
      this.changePassword = false
      this.confirmEmail = null
      this.oldEmail = null
      this.user = {
        name: null,
        second_name: null,
        lastname: null,
        second_lastname: null,
        username: null,
        email: null,
        password: null,
        user_status_id: 1,
        roles: []
      }
      this.person = {
        gender: null,
        birth_date: null,
        address: null,
        phone: null
      }
      this.roles = []
    },
    success (message, type) {
      this.$buefy.toast.open({
        message: message,
        type: type
      })
    },
    async getUser () {
      let params = {
        'include[0]': 'person',
        'include[1]': 'roles'
      }
      let response = await UserService.getUser(this.userId, params)
      let user = response.data.data
      this.user = JSON.parse(JSON.stringify(user))
      this.oldEmail = user.email
      this.confirmEmail = user.email
      this.person = user.person ? user.person : this.person
      this.birthDate = this.person && this.person.birth_date ? this.$moment(this.person.birth_date, 'YYYY-MM-DD').toDate() : null
      this.roles = this.user.roles.map(({ name }) => name)
      this.webAccess = !this.user.disabled_web
      this.mobileAccess = !this.user.disabled_mobile
    },
    async save () {
      if (await this.$refs.observer.validate()) {
        this.isLoading = true
        try {
          this.user.roles = this.roles
          if (this.userId) {
            let response = await UserService.updateUser(this.userId, this.user)
            if (response && this.person.id) {
              await PersonService.updatePerson(this.userId, this.person.id, this.person)
              this.success('Usuario editado exitosamente', 'is-success')
            } else {
              await PersonService.createPerson(this.userId, this.person)
              this.success('Usuario editado exitosamente', 'is-success')
            }
          } else {
            let response = await UserService.createUser(this.user)
            if (response.data.data) {
              let user = response.data.data
              await PersonService.createPerson(user.id, this.person)
              this.success('Usuario registrado exitosamente', 'is-success')
            }
          }
        } catch (error) {
          console.log(error)
          this.success('Ha ocurrido un error', 'is-danger')
        }

        setTimeout(() => {
          this.$emit('update:active', false)
          this.$emit('saved')
          this.resetForm()
          this.isLoading = false
        }, 3000)
      }
    },
    async verifyEmail (email, errors) {
      if ((this.oldEmail !== email) && (email !== '' && email.length > 1)) {
        let response = await UserService.verifyEmail(email)
        let existEmail = response.data.exist
        if (!existEmail) {
          this.confirmEmail = email
        } else {
          this.confirmEmail = null
        }
      } else if (this.oldEmail === email) {
        this.confirmEmail = email
      } else {
        this.confirmEmail = null
      }
    }
  },
  watch: {
    birthDate (data) {
      this.person.birth_date = data ? this.$moment(data).format('YYYY-MM-DD') : null
    },
    active (data) {
      if (this.active === true && this.userId) {
        this.getUser()
      }
    }
  },
  computed: {
    passwordConfirmStatus () {
      return this.user.password !== this.confirmPassword && this.confirmPassword != null ? 'is-danger' : ''
    },
    passwordConfirmMessage () {
      return this.user.password !== this.confirmPassword && this.confirmPassword != null ? ['Las contraseñas deben ser iguales'] : ''
    },
    emailAvailable () {
      return (this.confirmEmail === this.user.email) && this.user.email !== ''
    }
  }
}
</script>
